export default __webpack_public_path__ + "static/media/forbes.9e071970.svg";